export const getToken=()=>{
    let token = localStorage.getItem("EMP_TOKEN");;
    return token;
}
export const getTokenForJobSeeker=()=>{
    let token = localStorage.getItem("SEEKER_TOKEN");;
    return token;
}